import Loadable from 'react-loadable';

import PleaseWait from '~/components/loaders/please-wait';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "fti-consulting", webpackPrefetch: true */ './Fti-consulting.tsx'),
  loading: () => <PleaseWait />,
});
